export default "__VITE_ASSET__a74673ad__"